<template>
<div class="caroussel">
    <slot></slot>
    <button class="caroussel-nav caroussel-next" @click="next"><i class="fas fa-chevron-right" aria-hidden="true"></i></button>
    <button class="caroussel-nav caroussel-prev" @click="prev"><i class="fas fa-chevron-left" aria-hidden="true"></i></button>
    <div class="caroussel-pagination">
        <button v-for="n in slidesCount" @click="goto(n - 1)" :class="{ active: n - 1 == index }">
            <i class="fas fa-circle" aria-hidden="true"></i>
        </button>
    </div>
</div>
</template>

<script>
export default {
    data: () => ({
        index: 0,
        slides: [],
        direction: null
    }),
    mounted() {
        this.slides = this.$children;
        this.slides.forEach((slide, i) => {
            slide.index = i;
        });
    },
    computed: {
        slidesCount() {
            return this.slides.length;
        }
    },
    methods: {
        next() {
            this.index++;
            this.direction = 'right'
            if (this.index >= this.slidesCount) {
                this.index = 0;
            }
        },
        prev() {
            this.index--;
            this.direction = 'left'
            if (this.index < 0) {
                this.index = this.slidesCount - 1;
            }
        },
        goto(index) {
            this.direction = index > this.index ? 'right' : 'left';
            this.index = index;
        }

    }
}
</script>

<style>
.caroussel {
    position: relative;
    overflow: hidden;
    min-height: 60px;
    background: #f8f8f8;
}

.caroussel-nav {
    position: absolute;
    margin-top: -30px;
    top: 50%;
    left: 10px;
    border: 0;
    color: #fff;
    width: 60px;
    height: 60px;
    background: rgba(0, 0, 0, .6);
    font-size: 18px;
    line-height: 0;
    cursor: pointer;
}

.caroussel-next {
    right: 10px;
    left: auto;
}

.caroussel-pagination {
    position: absolute;
    left: 10px;
    right: 10px;
    bottom: 10px;
    text-align: center;
}

.caroussel-pagination button {
    margin: 0 5px;
    padding: 0;
    display: inline-block;
    opacity: .8;
    border: 0;
    background: transparent;
    color: #000;
    text-align: center;
    cursor: pointer;
    /*
    width: 14x;
    height: 14px;
    border-radius: 50%;*/
}

.caroussel-pagination button.active {
    /*background: #fff;*/
    color: #fff;
}
</style>
